import { lazy, Suspense, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ContentGroups, TranslationNamespaces } from '~/lib/constants';
import { Tagged } from '~/apps/smartsend/components/Tagged';
import { ContentContext, useAnalytics } from '@parcel2go/npm-p2g-app';
import { RoutingConstants } from '~/apps/smartsend/lib/consts/RoutingConstants';
import { GenerateBaseAnalyticsPayload } from '~/lib/utils/analytics';
import { NavigationContext } from '~/components/nav/nav-context';
import useOnLoad from '../use-on-load';

const PriceMatrix = lazy(() => import('~/apps/smartsend/components/pricematrix/PriceMatrix'));

export default function Component() {
  const { track } = useAnalytics();
  const { dispatch } = useContext(ContentContext);
  const { dispatch: navigationDispatch } = useContext(NavigationContext);
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);

  useOnLoad(() => {
    const title = t('POSTAGE_RATES_PAGE_TITLE', { defaultValue: 'Postage Rates' });
    document.title = title;
    dispatch({ type: 'SET_CONTENT_GROUP', contentGroup: ContentGroups.SMARTSEND });
    navigationDispatch({
      type: 'INITIALISE_NAVIGATION',
      payload: { title: title, currentPageRoute: RoutingConstants.Pricing }
    });
    track({
      type: 'page_view',
      payload: {
        ...GenerateBaseAnalyticsPayload([]),
        page: RoutingConstants.Pricing
      }
    });
  });

  return (
    <Tagged tag="screen-price-matrix">
      <Suspense>
        <PriceMatrix />
      </Suspense>
    </Tagged>
  );
}

Component.displayName = 'SmartSend: Postage Rates';
